import { dayjs, weappSDK, getLabel, request, RequestResult, RequestOptionConfig } from "@weapp/utils"
import { isNil } from "../../../utils"
import { Dialog } from '../../../lib'
import { checkStatusUrl } from '../constants'

const { message } = Dialog
interface AllUrls {
  [key: string]: string,
}

export function toDateTime(date: number) {
  if (typeof date !== 'number') return '';
  return dayjs(date).format('YYYY-MM-DD HH:mm')
}

export function toDate(date: number) {
  if (typeof date !== 'number') return '';
  return dayjs(date).format('YYYY-MM-DD')
}

const getUrls = (id: string, type: string, module: string = 'bs/hrm') => {
  let url = ''
  if (isNil(type) || !type || type === 'inside' || type === 'external' || type === 'wechat') {
    // no.2606808 外部联系人卡片调整组件模块支持
    // 如果模块没有穿指定的type，则判定为内部人员 统一走内部接口
    url = `/api/{module}/profile/getEmployeeCard?id=${id}`
  } else {
    // 统一处理接口中的模块标示
    const urls: AllUrls = {
      'department': `/api/{module}/department/queryDeptAndMembers?id=${id}`, // 部门
      'subcompany': `/api/{module}/subcompany/querysubcompanyAndMembers?id=${id}`, // 分部
      'group': '/api/bs/hrm/group/queryUser', // 群组
      'position': `/api/{module}/subcompany/queryPositionAndMembers?id=${id}`, //
    }
    url = urls[type] || ''
    if (!url) console.error('hrm-card type error!')
  }
  const field = /{module}/;
  return field.test(url) ? url.replace(field, (module || 'public')!) : url
}

export const getHrmData = (id: string, type: string, module: string) => {
  return new Promise((resolve, reject) => {
    const url = getUrls(id, type, module)
    const requestData: RequestOptionConfig = type === 'group' ? {
      url: url,
      method: 'POST',
      data: {
        "id": id,
        "menuCode": "groupManagement",
        "type": "group",
        "index": null,
        "orderKey": "",
        "orderType": "",
        "saMatchType": "AND",
        "saConditionList": [
          {
            "fieldCode": "sex",
            "ope": "eq",
            "value": "all"
          }
        ],
        "pageSize": 50000
      }
    } : {
      url: url,
      method: 'GET',
      params: {
        ifFilterCounts: true
      }
    }
    request(requestData).then((result: RequestResult) => {
      const resultType = result.data?.employeeType || result.data?.type || ''
      let finalType = ''
      if (type && type !== 'inside' && type !== 'external') {
        finalType = type
      } else {
        finalType = resultType ? resultType : 'inside'
      }
      resolve({
        allData: result.data || {},
        userData: result.data?.user || result.data?.employee || result.data?.group || result.data || result.data?.data || {},
        photoData: result.data?.photo,
        statistics: result.data?.profileCounts || {},
        follow: result.data?.userRelation?.type || 'none',
        ifSelf: result.data?.ifSelf,
        isWeaver: finalType === 'inside',
        dataStatus: result.status,
        dataMessage: result.msg,
        dataEmployeeType: finalType,
      })
    })
  })
}

export const getStatisticsData = (id: string, type: string, module: string) => {
  return new Promise((resolve, reject) => {
    request({
      url: `/api/bs/hrm/profile/getProfileCounts?id=${id}`,
    }).then((result: RequestResult) => {
      if (!result.status) {
        // message({
        //   type: 'error',
        //   content: result.data,
        // })
        reject();
      } else if (result.data) {
        resolve({
          statistics: result.data?.profileCounts || {},
        })
      }
      reject()
    })
  })
}

export const getWorkStatusData = (id: string) => {
  return new Promise((resolve, reject) => {
    request({
      url: `/api/bs/hrm/work_condition/config_batch`,
      method: 'POST',
      data: {
        "empIds": [
          id
        ]
      }
    }).then((result: RequestResult) => {
      if (!result.status) {
        // message({
        //   type: 'error',
        //   content: result.data,
        // })
        reject();
      } else if (result.data) {
        resolve({
          showWorkStatus: result.data?.[`${id}`],
        })
      }
      reject()
    })
  })
}

export const getDelMsg = (type?: string) => {
  let errorMsg = ''
  switch (type) {
    case 'department':
      errorMsg = getLabel('143675', '部门已经删除')
      break;
    case 'subcompany':
      errorMsg = getLabel('143676', '分部已经删除')
      break;
    case 'position':
      errorMsg = getLabel('143677', '岗位已经删除')
      break;
    default:
      errorMsg = getLabel('143678', '人员已经删除')
      break;
  }
  return errorMsg
}

export const openHrmLink = (id: string, type: string, url: string) => {
  return new Promise((resolve, reject) => {
    const params = type ? { id, type } : { id }
    request({
      url: checkStatusUrl,
      method: 'GET',
      params: params
    }).then((result: RequestResult) => {
      if (result?.data?.del) {
        message({
          type: "info",
          content: getDelMsg(type),
        })
      } else {
        url && weappSDK.openLink({
          url: url
        })
      }
      resolve({})
    }).catch((error) => {
      console.error(error)
      url && weappSDK.openLink({
        url: url
      })
    })
  })
}

export const isUserNameWechatConvert = (name: string = '') => {
  if (!name) return false
  const reg = new RegExp(/^\$userName=/, 'g')
  return reg.test(name)
}
